import { ProductImage } from './productImage.model';
import { ProductExtension } from './productExtension.model';

export class Child extends ProductExtension {
    _id: string;
    INTsku: string;
    productName: string;
    productId: string;
    manufactureInfo: string;
    vendorId: string;
    brandName: string;
    hsnCode: string;
    gstIn: string;
    headChild: boolean;
    sku: string;
    styleCode: string;
    variation: string;
    productsType: string;
    packOf: number;
    size: string;
    weight: string;
    fabric: string;
    washCare: string;
    productDimension: string;
    packingDimension: string;
    discount: number;
    sp: number;
    mrp: string;
    closure: string;
    pattern: string;
    productDescription: string | [string];
    toFitWaist: string;
    searchTerms1: string;
    searchTerms2: string;
    searchTerms3: string;
    searchTerms4: string;
    searchTerms5: string;
    superCategoryId: string;
    superCategoryName: string;
    mainCategoryId: string;
    mainCategoryName: string;
    subCategoryId: string;
    subCategoryName: string;
    variantId: string;
    variationTypeId: string;
    bulletPoints: string;
    sizeVariantId: string;
    sizeVariant: string;
    colorFields: any;
    colorName: string;
    colorId: string;
    tags: string;
    metaTitle: string;
    metaDescription: string;
    metaKeyword: string;
    dateAdded: Date;
    dateModified: Date;
    brandId: string;
    variationType: string;
    publish: boolean;
    sizeName: string;
    sizeId: string;
    quantity: number;
    price: number;
    productImage: [ProductImage];
    attribute: any;
    length: string;
    breath: string;
    hsn: string;
    tp: string;
    ttsPortol: string;
    ttsVendor: string;
    sizeIncApply: boolean;
    sizeIncType: string;
    sizeWisePrice: number;
    costIncludes: string | [string];
}
